import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { signOut } from '../../../redux/auth/auth.actions';

import { selectIsSidebarCollapsed, selectIsSidebarProfileMenuEnabled } from '../../../redux/main/main.selectors';
import { toggleSidebarProfileMenu } from '../../../redux/main/main.actions';


import {
    ModeDarkIcon,
    ModeLightIcon,
} from '../../Icon';

import './ModalProfileMenu.scss';

export const ModalProfileMenu = () => {
    const history = useHistory();

    const isSidebarCollapsed = useSelector(selectIsSidebarCollapsed);
    const isOpen = useSelector(selectIsSidebarProfileMenuEnabled);

    const [shouldRender, setShouldRender] = useState(isOpen);
    const [animationClass, setAnimationClass] = useState('');

    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
            setAnimationClass('fade-in');
        } else if (shouldRender) {
            setAnimationClass('fade-out');
        }
    }, [isOpen]);

    const handleAnimationEnd = () => {
        if (!isOpen) {
            setShouldRender(false);
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleCancel();
        }
    };

    const dispatch = useDispatch();

    const handleCancel = () => {
        dispatch(toggleSidebarProfileMenu({}));
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (!isOpen) return;

            if (event.code === 'Escape') {
                event.preventDefault();

                handleCancel();
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [isOpen, handleCancel]);

    if (!shouldRender) return null;

    return (
        <div className="modal-profile-menu">
            <div className="modal-overlay" onClick={handleOverlayClick}></div>
            <div
                className={`profile-menu ${animationClass} ${isSidebarCollapsed ? 'collapsed' : ''}`}
                onAnimationEnd={handleAnimationEnd}
            >
                <div className="control">
                    <button
                        className={`control-button`}
                        type="button"
                        title=""
                        aria-label="Color"
                        aria-pressed="false"
                        onClick={() => {
                            const url = `/settings/profile`;
                            // setTimeout(() => {
                            dispatch(toggleSidebarProfileMenu());
                            history.push(url);
                            // }, 100);
                        }}
                    >

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        View profile
                    </button>
                </div>

                {/* without 'toggle theme' */}
                {/* <div className="control">
                    <button
                        // className={`control-button ${isBtnExportCodeEnabled ? 'selected' : ''}`}
                        className={`control-button`}
                        type="button"
                        title=""
                        aria-label="Color"
                        aria-pressed="false"
                        onClick={() => {
                            // dispatch(toggleBtnExportCode());
                        }}
                    > */}
                {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"></path><path d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"></path><path d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"></path><path d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"></path></svg> */}
                {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"><path d="M5 21V14M5 10V3M12 21V12M12 8V3M19 21V16M19 12V3M2 14H8M9 8H15M16 16H22"></path></svg> */}

                {/* <ModeLightIcon />
                        Toggle theme
                    </button>
                </div> */}

                {/* <div className="horizontal-line"></div> */}

                <div className="control">
                    <button
                        className={`control-button`}
                        type="button"
                        title=""
                        aria-label="Color"
                        aria-pressed="false"
                        onClick={() => {
                            dispatch(toggleSidebarProfileMenu());
                            setTimeout(() => { window.open('https://dbdesign.io', '_blank'); }, 100)
                        }}
                    >

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{
                            width: '17px',
                            marginRight: '1px'
                        }}><path d="M12.982 2.764c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0c-.194.052-.37.189-.721.462L4.235 8.039c-.453.353-.68.53-.843.75a2 2 0 0 0-.318.65C3 9.704 3 9.991 3 10.565V17.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21h2c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218C9 20.62 9 20.48 9 20.2v-6.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C9.76 12 10.04 12 10.6 12h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C15 12.76 15 13.04 15 13.6v6.6c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h2c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.48 21 18.92 21 17.8v-7.235c0-.574 0-.861-.074-1.126a2 2 0 0 0-.318-.65c-.163-.22-.39-.397-.843-.75z"></path></svg>
                        Homepage
                    </button>
                </div>

                {/* <div className="control">
                    <button
                        className={`control-button`}
                        type="button"
                        title=""
                        aria-label="Color"
                        aria-pressed="false"
                        onClick={() => {
                            const url = `/guides-shortcuts/onboarding`;
                            // setTimeout(() => {
                            dispatch(toggleSidebarProfileMenu());
                            history.push(url);
                            // }, 100);
                        }}
                    >
                        <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M11.5 5H11.9344C14.9816 5 16.5053 5 17.0836 5.54729C17.5836 6.02037 17.8051 6.71728 17.6702 7.39221C17.514 8.17302 16.2701 9.05285 13.7823 10.8125L9.71772 13.6875C7.2299 15.4471 5.98599 16.327 5.82984 17.1078C5.69486 17.7827 5.91642 18.4796 6.41636 18.9527C6.99474 19.5 8.51836 19.5 11.5656 19.5H12.5M8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5ZM22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19Z"></path></svg>

                        Onboarding
                    </button>
                </div> */}

                <div className="horizontal-line"></div>

                <div className="control">
                    <button
                        className={`control-button`}
                        type="button"
                        title=""
                        aria-label="Color"
                        aria-pressed="false"
                        onClick={() => {
                            console.log('ddd');
                            dispatch(toggleSidebarProfileMenu());
                            dispatch(signOut())
                        }}

                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" x2="9" y1="12" y2="12"></line></svg>
                        Sign out
                    </button>
                </div>

            </div>
        </div>
    );
};

export default ModalProfileMenu;
